/** Выбор игрока, который переживает перезапуск: скорость и автонавыки. */
import { ADMIN_SPEEDS, appStore, patch, type AppState, type BattleSpeed } from "./app-state";

const SPEED_KEY = "nfg:speed";
const AUTO_KEY = "nfg:auto";

function savePref(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // без localStorage выбор держится до перезагрузки
  }
}

/** Выбор x2 и автонавыков с прошлого запуска. */
export function readBattlePrefs(): Pick<AppState, "speedPref" | "autoPref"> {
  try {
    const ls = window.localStorage;
    const speedPref = ADMIN_SPEEDS.find((v) => String(v) === ls.getItem(SPEED_KEY)) ?? 1;
    return { speedPref, autoPref: ls.getItem(AUTO_KEY) === "1" };
  } catch {
    return { speedPref: 1, autoPref: false };
  }
}

export function setSpeedPref(speedPref: BattleSpeed, store = appStore): void {
  savePref(SPEED_KEY, String(speedPref));
  patch(() => ({ speedPref }), store);
}

/** Следующий шаг кнопки скорости админа. */
export function cycleAdminSpeed(store = appStore): void {
  const i = ADMIN_SPEEDS.indexOf(store.get().speedPref);
  setSpeedPref(ADMIN_SPEEDS[(i + 1) % ADMIN_SPEEDS.length]!, store);
}

export function setAutoPref(autoPref: boolean, store = appStore): void {
  savePref(AUTO_KEY, autoPref ? "1" : "0");
  patch(() => ({ autoPref }), store);
}
